<template>
  <ya-site-resource-list resource="member" />
</template>

<script>
import YaSiteResourceList from './resourceList'

export default {
  name: 'YaSiteMemberList',
  components: { YaSiteResourceList },
}
</script>
